import { render, staticRenderFns } from "./TjingClickToolTip.vue?vue&type=template&id=3a3ad5e2&scoped=true"
import script from "./TjingClickToolTip.vue?vue&type=script&lang=js"
export * from "./TjingClickToolTip.vue?vue&type=script&lang=js"
import style0 from "./TjingClickToolTip.vue?vue&type=style&index=0&id=3a3ad5e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3ad5e2",
  null
  
)

export default component.exports